import * as Font from 'expo-font';

export const FONTS = {
  'Poppins-Regular': require('../assets/fonts/Poppins-Regular.ttf'),
  'Poppins-Medium': require('../assets/fonts/Poppins-Medium.ttf'),
  'Poppins-SemiBold': require('../assets/fonts/Poppins-SemiBold.ttf'),
};

export const FONT_FAMILY = {
  regular: 'Poppins-Regular',
  medium: 'Poppins-Medium',
  semiBold: 'Poppins-SemiBold',
};

export const loadFonts = async () => {
  await Font.loadAsync(FONTS);
};

export const Typography = {
  header1: {
    fontFamily: FONT_FAMILY.semiBold,
    fontSize: 32,
    letterSpacing: -0.5,
    lineHeight: 40,
  },
  header2: {
    fontFamily: FONT_FAMILY.medium,
    fontSize: 24,
    letterSpacing: -0.3,
  },
  header3: {
    fontFamily: FONT_FAMILY.medium,
    fontSize: 20,
    letterSpacing: -0.2,
  },
  body1: {
    fontFamily: FONT_FAMILY.regular,
    fontSize: 16,
  },
  body2: {
    fontFamily: FONT_FAMILY.regular,
    fontSize: 14,
  },
  caption: {
    fontFamily: FONT_FAMILY.regular,
    fontSize: 12,
  },
  button: {
    fontFamily: FONT_FAMILY.medium,
    fontSize: 16,
    letterSpacing: 0.2,
  },
};
